import * as yup from 'yup';
import { tiposPropiedadesConSubtipos } from '../propertyWizard/steps/OperacionYPropiedad';

export const OperationAndPropertieSchema = yup.object().shape({
  branch_office_id: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('Este campo es obligatorio')
    .typeError('Número inválido'),
  operation_type: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('Este campo es obligatorio')
    .typeError('Número inválido'),
  property_type: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('Este campo es obligatorio')
    .typeError('Número inválido'),
  sub_property_type: yup
    .number()
    .when('property_type', (property_type, schema) => {
      if (tiposPropiedadesConSubtipos.includes(property_type)) {
        return schema.required('Este campo es obligatorio');
      }
      return schema;
    }),
  title: yup
    .string()
    .required('Este campo es obligatorio')
    .min(8, 'Mínimo 8 caracteres')
    .max(150, 'Máximo 150 caracteres'),
  owner: yup.object().shape({
    name: yup.string().max(60, 'Máximo 60 caracteres'),
    email: yup.string().email('Email inválido')
  })
});

export const LocationSchema = yup.object().shape({
  street: yup.string().required('Este campo es obligatorio'),
  number: yup
    .number()
    .required('Este campo es obligatorio')
    .positive('El número debe ser mayor a 0')
    .typeError('Número inválido'),
  barrios: yup
    .array()
    .required('Este campo es obligatorio')
    .min(1, 'Debe seleccionar al menos un barrio'),
  letter: yup.string()
});
